import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconPlay from 'components/icons/IconPlay';
import IconPlus from 'components/icons/iconPlus';
import useVideoMetadata from 'hooks/useVideoMetadata';
import PDPGalleryRevampLifestyleThumb from '../PDPDesktopGalleryRevamp/PDPGalleryRevampLifestyleThumb';
const THUMB_CLASS = 'h-[42px] w-14 shrink-0';

// Horizontal strip: video, lifestyle photos, "+" to expand
const PDPMobileGalleryRevampThumbRail = t0 => {
  const $ = _c(29);
  const {
    introVideoId,
    isVideoSelected: t1,
    onExpand,
    onSelectVideo,
    photos: t2,
    viewGalleryImageEvent
  } = t0;
  const isVideoSelected = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const photos = t3;
  let t4;
  if ($[2] !== introVideoId) {
    t4 = {
      videoId: introVideoId
    };
    $[2] = introVideoId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    thumbnail: videoThumbnailUrl
  } = useVideoMetadata(t4);
  if (!photos.length) {
    return null;
  }
  let t5;
  if ($[4] !== introVideoId || $[5] !== isVideoSelected || $[6] !== onSelectVideo || $[7] !== videoThumbnailUrl) {
    t5 = !!introVideoId && <PDPGalleryRevampLifestyleThumb ariaLabel="Play product video" className={THUMB_CLASS} src={videoThumbnailUrl} isSelected={isVideoSelected} onClick={onSelectVideo} icon={<IconPlay width={20} height={20} />} />;
    $[4] = introVideoId;
    $[5] = isVideoSelected;
    $[6] = onSelectVideo;
    $[7] = videoThumbnailUrl;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onExpand || $[10] !== photos || $[11] !== viewGalleryImageEvent) {
    let t7;
    if ($[13] !== onExpand || $[14] !== photos.length || $[15] !== viewGalleryImageEvent) {
      t7 = (t8, index) => {
        const {
          id,
          src
        } = t8;
        return <PDPGalleryRevampLifestyleThumb key={`PDPMobileGalleryRevampRailThumb${id}`} className={THUMB_CLASS} src={src} onClick={() => {
          onExpand(index);
          viewGalleryImageEvent?.({
            imageLocation: "Hero Gallery",
            imageFilename: src?.split("/").pop() || "",
            position: index,
            totalImages: photos.length
          });
        }} />;
      };
      $[13] = onExpand;
      $[14] = photos.length;
      $[15] = viewGalleryImageEvent;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = photos.map(t7);
    $[9] = onExpand;
    $[10] = photos;
    $[11] = viewGalleryImageEvent;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex gap-1.5 min-w-0 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = `Show all ${photos.length} photos`;
  let t9;
  if ($[20] !== onExpand) {
    t9 = () => onExpand(0);
    $[20] = onExpand;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconPlus width={14} height={14} />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t8 || $[24] !== t9) {
    t11 = <PDPGalleryRevampLifestyleThumb ariaLabel={t8} className={THUMB_CLASS} borderClass="border-gray-light5" onClick={t9}>{t10}</PDPGalleryRevampLifestyleThumb>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t7) {
    t12 = <div className="flex gap-1.5" data-xc="PDPMobileGalleryRevampThumbRail">{t7}{t11}</div>;
    $[26] = t11;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
PDPMobileGalleryRevampThumbRail.propTypes = {
  introVideoId: PropTypes.string,
  isVideoSelected: PropTypes.bool,
  onExpand: PropTypes.func,
  onSelectVideo: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  viewGalleryImageEvent: PropTypes.func
};
export default PDPMobileGalleryRevampThumbRail;